import { makeAutoObservable } from 'mobx'
import { Document, Endpoint } from 'mobx-document'
import authenticationStore from './authenticationStore'
import { SearchEndpointOptions, SearchMeta, SearchParams } from './search'
import { register } from './support'

export class SearchStore {

  constructor() {
    makeAutoObservable(this)
  }

  public readonly endpoints: Map<string, [SearcheableEndpoint<any>, SearchEndpointOptions]> = new Map()

  public registerEndpoint<E extends SearcheableEndpoint<any, any, any>>(resource: string, endpoint: E, options?: SearchEndpointOptions) {
    this.endpoints.set(resource, [endpoint, options ?? {}])
  }

  public unregisterEndpoint(resource: string) {
    this.endpoints.delete(resource)
  }

  public getEndpoint(resource: string): [SearcheableEndpoint<any> | null, SearchEndpointOptions] {
    const [endpoint, options] = this.endpoints.get(resource) ?? [null, {}]
    if (endpoint == null) {
      console.warn(`Endpoint for resource "${resource}" not available`)
    }

    return [endpoint, options]
  }

  public get allEndpoints() {
    return Array.from(this.endpoints.values()).map((([endpoint]) => endpoint))
  }

  //------
  // Searching

  public search(query: string | null) {
    if (query == null) {
      this.allEndpoints.forEach(endpoint => endpoint.clear())
    } else {
      this.allEndpoints.forEach(endpoint => endpoint.fetchWithParams({query}, {limit: 20}))
    }
  }

  //------
  // Log out

  public init() {
    authenticationStore.on('logout', this.onLogOut)
  }

  public onLogOut = () => {
    for (const [endpoint] of this.endpoints.values()) {
      endpoint.clear()
    }
  }
}

export default register(new SearchStore())

export type SearcheableEndpoint<
  D extends Document<any>,
  P extends SearchParams = SearchParams,
  M extends SearchMeta = SearchMeta,
> = Endpoint<D, P, M> & {
  fetchMore: () => Promise<any>
}